module.exports = {
	"contractName": "ButtonClickGameContract",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "name",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_tokenId",
					"type": "uint256"
				}
			],
			"name": "getApproved",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_to",
					"type": "address"
				},
				{
					"name": "_tokenId",
					"type": "uint256"
				}
			],
			"name": "approve",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "addr",
					"type": "address"
				},
				{
					"name": "roleName",
					"type": "string"
				}
			],
			"name": "checkRole",
			"outputs": [],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "totalSupply",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_minimumFee",
					"type": "uint256"
				}
			],
			"name": "setMinimumFee",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "minimumFee",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "started",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "addr",
					"type": "address"
				},
				{
					"name": "roleName",
					"type": "string"
				}
			],
			"name": "hasRole",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_from",
					"type": "address"
				},
				{
					"name": "_to",
					"type": "address"
				},
				{
					"name": "_tokenId",
					"type": "uint256"
				}
			],
			"name": "transferFrom",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "requiredBlocksElapsedForVictory",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "uint8"
				}
			],
			"name": "numberOfClicksAtBlocksRemaining",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_owner",
					"type": "address"
				},
				{
					"name": "_index",
					"type": "uint256"
				}
			],
			"name": "tokenOfOwnerByIndex",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "blockNumberForVictory",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "clickButton",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_requiredBlocksElapsedForVictory",
					"type": "uint256"
				}
			],
			"name": "setRequiredBlocksElapsedForVictory",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_from",
					"type": "address"
				},
				{
					"name": "_to",
					"type": "address"
				},
				{
					"name": "_tokenId",
					"type": "uint256"
				}
			],
			"name": "safeTransferFrom",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_tokenId",
					"type": "uint256"
				}
			],
			"name": "exists",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_index",
					"type": "uint256"
				}
			],
			"name": "tokenByIndex",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "withdrawBalance",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_tokenId",
					"type": "uint256"
				}
			],
			"name": "ownerOf",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_id",
					"type": "uint256"
				}
			],
			"name": "getClickMetadata",
			"outputs": [
				{
					"name": "blocksAwayFromDesiredBlock",
					"type": "uint256"
				},
				{
					"name": "clickTime",
					"type": "uint256"
				},
				{
					"name": "clickGeneration",
					"type": "uint256"
				},
				{
					"name": "owner",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"name": "addressLastClickedForGeneration",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_owner",
					"type": "address"
				}
			],
			"name": "balanceOf",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "addr",
					"type": "address"
				},
				{
					"name": "roleName",
					"type": "string"
				}
			],
			"name": "adminRemoveRole",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "symbol",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_to",
					"type": "address"
				},
				{
					"name": "_approved",
					"type": "bool"
				}
			],
			"name": "setApprovalForAll",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "addr",
					"type": "address"
				},
				{
					"name": "roleName",
					"type": "string"
				}
			],
			"name": "adminAddRole",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_from",
					"type": "address"
				},
				{
					"name": "_to",
					"type": "address"
				},
				{
					"name": "_tokenId",
					"type": "uint256"
				},
				{
					"name": "_data",
					"type": "bytes"
				}
			],
			"name": "safeTransferFrom",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_tokenId",
					"type": "uint256"
				}
			],
			"name": "tokenURI",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "ROLE_ADMIN",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [
				{
					"name": "_owner",
					"type": "address"
				},
				{
					"name": "_operator",
					"type": "address"
				}
			],
			"name": "isApprovedForAll",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "gameGeneration",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "owner",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "tokenId",
					"type": "uint256"
				}
			],
			"name": "ButtonClick",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "addr",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "roleName",
					"type": "string"
				}
			],
			"name": "RoleAdded",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": false,
					"name": "addr",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "roleName",
					"type": "string"
				}
			],
			"name": "RoleRemoved",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "_from",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "_to",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_tokenId",
					"type": "uint256"
				}
			],
			"name": "Transfer",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "_owner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "_approved",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_tokenId",
					"type": "uint256"
				}
			],
			"name": "Approval",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"name": "_owner",
					"type": "address"
				},
				{
					"indexed": true,
					"name": "_operator",
					"type": "address"
				},
				{
					"indexed": false,
					"name": "_approved",
					"type": "bool"
				}
			],
			"name": "ApprovalForAll",
			"type": "event"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "startGame",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "sendDeposit",
			"outputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "59:1075:1:-;;;268:5:2;246:27;;;;;;;;;;;;;;;;;;;;1765:1:0;1733:33;;189:421:1;;;;;;;;1107:105:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1179:5;1171;:13;;;;;;;;;;;;:::i;:::-;;1200:7;1190;:17;;;;;;;;;;;;:::i;:::-;;1107:105;;1016:31:7;1024:10;1036;;;;;;;;;;;;;;;;;;1016:7;;;;;:31;;;:::i;:::-;325::1;333:10;345;;;;;;;;;;;;;;;;;;325:7;;;;;:31;;;:::i;:::-;366:33;374:10;386:12;;;;;;;;;;;;;;;;;;366:7;;;;;:33;;;:::i;:::-;423:15;410:10;:28;;;;569:2;535:31;:36;;;;59:1075;;2169:130:7;2238:25;2258:4;2238:5;2244:8;2238:15;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;2238:15:7;;;;;;;;;;;;;;;;;;;;;:19;;;;;;:25;;;;;:::i;:::-;2269;2279:4;2285:8;2269:25;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;2269:25:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2169:130;;:::o;326:96:8:-;413:4;393;:11;;:17;405:4;393:17;;;;;;;;;;;;;;;;:24;;;;;;;;;;;;;;;;;;326:96;;:::o;59:1075:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;",
	"deployedSourceMap": "59:1075:1:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1075:56;;;;;;1303:68:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;1303:68:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3577:111:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2998:350;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1196:110:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2887:87:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1440:106:2;;;;;;;;;;;;;;;;;;;;;;;;;;578:25;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;246:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1444:132:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5042:315:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;793:46:2;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2483:65:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2571:177:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1944:36:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2938:2131;;;;;;;;;;;;;;;;;;;;;;;1143:188:2;;;;;;;;;;;;;;;;;;;;;;;;;;5964:154:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2445:140;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3298::14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1659:107:2;;;;;;;;;;;;;;2107:164:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;5213:486:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2236:67;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1756:142:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1931:120:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1466:72:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;1466:72:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;3969:200:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1694:114:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;6794:227:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1727:133:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;1727:133:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;862:43:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;862:43:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;710:178:1;;;;;;;;;;;;;;4478:142:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1733:33:0;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1075:56:1;:::o;1303:68:14:-;1340:6;;:::i;:::-;1361:5;1354:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1303:68;:::o;3577:111:12:-;3637:7;3659:14;:24;3674:8;3659:24;;;;;;;;;;;;;;;;;;;;;3652:31;;3577:111;;;:::o;2998:350::-;3059:13;3075:17;3083:8;3075:7;:17::i;:::-;3059:33;;3113:5;3106:12;;:3;:12;;;;3098:21;;;;;;;;3147:5;3133:19;;:10;:19;;;:58;;;;3156:35;3173:5;3180:10;3156:16;:35::i;:::-;3133:58;3125:67;;;;;;;;3236:1;3203:35;;:21;3215:8;3203:11;:21::i;:::-;:35;;;;:56;;;;3257:1;3242:17;;:3;:17;;;;3203:56;3199:145;;;3296:3;3269:14;:24;3284:8;3269:24;;;;;;;;;;;;:30;;;;;;;;;;;;;;;;;;3323:3;3307:30;;3316:5;3307:30;;;3328:8;3307:30;;;;;;;;;;;;;;;;;;3199:145;2998:350;;;:::o;1196:110:7:-;1274:27;1296:4;1274:5;1280:8;1274:15;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;1274:15:7;;;;;;;;;;;;;;;;;;;;;:21;;:27;;;;:::i;:::-;1196:110;;:::o;2887:87:14:-;2931:7;2953:9;:16;;;;2946:23;;2887:87;:::o;1440:106:2:-;385:35:3;395:10;407:12;;;;;;;;;;;;;;;;;;385:9;:35::i;:::-;1528:11:2;1515:10;:24;;;;1440:106;:::o;578:25::-;;;;:::o;246:27::-;;;;;;;;;;;;;:::o;1444:132:7:-;1525:4;1546:25;1566:4;1546:5;1552:8;1546:15;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;1546:15:7;;;;;;;;;;;;;;;;;;;;;:19;;:25;;;;:::i;:::-;1539:32;;1444:132;;;;:::o;5042:315:12:-;5129:8;1516:39;1534:10;1546:8;1516:17;:39::i;:::-;1508:48;;;;;;;;5170:1;5153:19;;:5;:19;;;;5145:28;;;;;;;;5202:1;5187:17;;:3;:17;;;;5179:26;;;;;;;;5212:30;5226:5;5233:8;5212:13;:30::i;:::-;5248:32;5264:5;5271:8;5248:15;:32::i;:::-;5286:25;5297:3;5302:8;5286:10;:25::i;:::-;5338:3;5322:30;;5331:5;5322:30;;;5343:8;5322:30;;;;;;;;;;;;;;;;;;5042:315;;;;:::o;793:46:2:-;;;;:::o;2483:65:0:-;;;;;;;;;;;;;;;;;:::o;2571:177:14:-;2653:7;2685:17;2695:6;2685:9;:17::i;:::-;2676:6;:26;2668:35;;;;;;;;2716:11;:19;2728:6;2716:19;;;;;;;;;;;;;;;2736:6;2716:27;;;;;;;;;;;;;;;;;;;2709:34;;2571:177;;;;:::o;1944:36:0:-;;;;:::o;2938:2131::-;2997:7;3720:35;4059:19;4568:33;;:::i;:::-;4808:18;988:7:2;;;;;;;;;;;980:16;;;;;;;;3091:10:0;;3078:9;:23;;3070:32;;;;;;;;3197:5;3179:14;;:23;;3171:32;;;;;;;;3350:14;;3304:31;:43;3336:10;3304:43;;;;;;;;;;;;;;;;:60;3296:69;;;;;;;;3498:14;;3452:31;:43;3484:10;3452:43;;;;;;;;;;;;;;;:60;;;;3793:12;3769:21;;:36;3765:195;;;3875:12;3851:21;;:36;3821:66;;3765:195;;;3948:1;3918:31;;3765:195;4081:14;;4059:36;;4172:1;4141:27;:32;4137:79;;;4189:14;;:16;;;;;;;;;;;;;4137:79;4363:1;4292:31;:67;4330:27;4292:67;;;;;;;;;;;;;;;;:72;;;;;;;;;;;4496:31;;4481:12;:46;4457:21;:70;;;;4604:194;;;;;;;;;4673:27;4604:194;;;;;;4739:11;4604:194;;;;;;4783:3;4604:194;;;;;4568:230;;4851:1;4829:6;:19;;;;;;;;;;;:::i;:::-;;;;;;;;;;4841:6;4829:19;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:23;4808:44;;4912:10;4900:35;;;4924:10;4900:35;;;;;;;;;;;;;;;;;;5005:29;5011:10;5023;5005:5;:29::i;:::-;5052:10;5045:17;;2938:2131;;;;;:::o;1143:188:2:-;2904:33:7;2914:10;2926;;;;;;;;;;;;;;;;;;2904:9;:33::i;:::-;1292:32:2;1258:31;:66;;;;1143:188;:::o;5964:154:12:-;6055:8;1516:39;1534:10;1546:8;1516:17;:39::i;:::-;1508:48;;;;;;;;6071:42;6088:5;6095:3;6100:8;6071:42;;;;;;;;;;;;;:16;:42::i;:::-;5964:154;;;;:::o;2445:140::-;2500:4;2512:13;2528:10;:20;2539:8;2528:20;;;;;;;;;;;;;;;;;;;;;2512:36;;2578:1;2561:19;;:5;:19;;;;2554:26;;2445:140;;;;:::o;3298::14:-;3357:7;3389:13;:11;:13::i;:::-;3380:6;:22;3372:31;;;;;;;;3416:9;3426:6;3416:17;;;;;;;;;;;;;;;;;;;3409:24;;3298:140;;;:::o;1659:107:2:-;385:35:3;395:10;407:12;;;;;;;;;;;;;;;;;;385:9;:35::i;:::-;1717:10:2;:19;;:42;1745:4;1737:21;;;1717:42;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1659:107::o;2107:164:12:-;2163:7;2178:13;2194:10;:20;2205:8;2194:20;;;;;;;;;;;;;;;;;;;;;2178:36;;2245:1;2228:19;;:5;:19;;;;2220:28;;;;;;;;2261:5;2254:12;;2107:164;;;;:::o;5213:486:0:-;5284:34;5328:17;5355:23;5388:13;5418:36;5457:6;5464:3;5457:11;;;;;;;;;;;;;;;;;;5418:50;;5516:8;:35;;;;;;;;;;;;5508:44;;5479:73;;5582:8;:18;;;;;;;;;;;;5574:27;;5562:39;;5637:8;:24;;;;;;;;;;;;5629:33;;5611:51;;5680:12;5688:3;5680:7;:12::i;:::-;5672:20;;5213:486;;;;;;:::o;2236:67::-;;;;;;;;;;;;;;;;;:::o;1756:142:12:-;1812:7;1853:1;1835:20;;:6;:20;;;;1827:29;;;;;;;;1869:16;:24;1886:6;1869:24;;;;;;;;;;;;;;;;1862:31;;1756:142;;;:::o;1931:120:7:-;2904:33;2914:10;2926;;;;;;;;;;;;;;;;;;2904:9;:33::i;:::-;2020:26;2031:4;2037:8;2020:10;:26::i;:::-;1931:120;;:::o;1466:72:14:-;1505:6;;:::i;:::-;1526:7;1519:14;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1466:72;:::o;3969:200:12:-;4053:10;4046:17;;:3;:17;;;;4038:26;;;;;;;;4107:9;4070:17;:29;4088:10;4070:29;;;;;;;;;;;;;;;:34;4100:3;4070:34;;;;;;;;;;;;;;;;:46;;;;;;;;;;;;;;;;;;4149:3;4122:42;;4137:10;4122:42;;;4154:9;4122:42;;;;;;;;;;;;;;;;;;;;;;3969:200;;:::o;1694:114:7:-;2904:33;2914:10;2926;;;;;;;;;;;;;;;;;;2904:9;:33::i;:::-;1780:23;1788:4;1794:8;1780:7;:23::i;:::-;1694:114;;:::o;6794:227:12:-;6898:8;1516:39;1534:10;1546:8;1516:17;:39::i;:::-;1508:48;;;;;;;;6914:34;6927:5;6934:3;6939:8;6914:12;:34::i;:::-;6962:53;6987:5;6994:3;6999:8;7009:5;6962:24;:53::i;:::-;6954:62;;;;;;;;6794:227;;;;;:::o;1727:133:14:-;1784:6;;:::i;:::-;1806:16;1813:8;1806:6;:16::i;:::-;1798:25;;;;;;;;1836:9;:19;1846:8;1836:19;;;;;;;;;;;1829:26;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;1727:133;;;:::o;862:43:7:-;;;;;;;;;;;;;;;;;;;;:::o;710:178:1:-;2904:33:7;2914:10;2926;;;;;;;;;;;;;;;;;;2904:9;:33::i;:::-;769:7:1;;;;;;;;;;;768:8;760:17;;;;;;;;797:4;787:7;;:14;;;;;;;;;;;;;;;;;;850:31;;835:12;:46;811:21;:70;;;;710:178::o;4478:142:12:-;4560:4;4579:17;:25;4597:6;4579:25;;;;;;;;;;;;;;;:36;4605:9;4579:36;;;;;;;;;;;;;;;;;;;;;;;;;4572:43;;4478:142;;;;:::o;1733:33:0:-;;;;:::o;663:107:8:-;749:15;753:4;759;749:3;:15::i;:::-;741:24;;;;;;;;663:107;;:::o;848:124::-;929:4;950;:11;;:17;962:4;950:17;;;;;;;;;;;;;;;;;;;;;;;;;943:24;;848:124;;;;:::o;7368:240:12:-;7454:4;7466:13;7482:17;7490:8;7482:7;:17::i;:::-;7466:33;;7524:5;7512:17;;:8;:17;;;:54;;;;7558:8;7533:33;;:21;7545:8;7533:11;:21::i;:::-;:33;;;7512:54;:91;;;;7570:33;7587:5;7594:8;7570:16;:33::i;:::-;7512:91;7505:98;;7368:240;;;;;:::o;8653:260::-;8754:6;8733:27;;:17;8741:8;8733:7;:17::i;:::-;:27;;;8725:36;;;;;;;;8807:1;8771:38;;:14;:24;8786:8;8771:24;;;;;;;;;;;;;;;;;;;;;:38;;;;8767:142;;;8854:1;8819:14;:24;8834:8;8819:24;;;;;;;;;;;;:37;;;;;;;;;;;;;;;;;;8889:1;8864:38;;8873:6;8864:38;;;8893:8;8864:38;;;;;;;;;;;;;;;;;;8767:142;8653:260;;:::o;4198:856:14:-;4316:18;4369:22;4432:17;4271:38;4293:5;4300:8;4271:21;:38::i;:::-;4337:16;:26;4354:8;4337:26;;;;;;;;;;;;4316:47;;4394:32;4424:1;4394:11;:18;4406:5;4394:18;;;;;;;;;;;;;;;:25;;;;:29;;:32;;;;:::i;:::-;4369:57;;4452:11;:18;4464:5;4452:18;;;;;;;;;;;;;;;4471:14;4452:34;;;;;;;;;;;;;;;;;;;4432:54;;4526:9;4493:11;:18;4505:5;4493:18;;;;;;;;;;;;;;;4512:10;4493:30;;;;;;;;;;;;;;;;;;:42;;;;4578:1;4541:11;:18;4553:5;4541:18;;;;;;;;;;;;;;;4560:14;4541:34;;;;;;;;;;;;;;;;;;:38;;;;4940:11;:18;4952:5;4940:18;;;;;;;;;;;;;;;:27;;;;;;;;;;;;:::i;:::-;;5002:1;4973:16;:26;4990:8;4973:26;;;;;;;;;;;:30;;;;5039:10;5009:16;:27;5026:9;5009:27;;;;;;;;;;;:40;;;;4198:856;;;;;:::o;3697:226::-;3800:14;3763:31;3780:3;3785:8;3763:16;:31::i;:::-;3817:11;:16;3829:3;3817:16;;;;;;;;;;;;;;;:23;;;;3800:40;;3846:11;:16;3858:3;3846:16;;;;;;;;;;;;;;;:31;;;;;;;;;;;:::i;:::-;;;;;;;;;;3868:8;3846:31;;;;;;;3912:6;3883:16;:26;3900:8;3883:26;;;;;;;;;;;:35;;;;3697:226;;;:::o;5315:176::-;5376:26;5388:3;5393:8;5376:11;:26::i;:::-;5440:9;:16;;;;5413:14;:24;5428:8;5413:24;;;;;;;;;;;:43;;;;5462:9;:24;;;;;;;;;;;:::i;:::-;;;;;;;;;;5477:8;5462:24;;;;;;;5315:176;;:::o;2422:138:7:-;2494:28;2517:4;2494:5;2500:8;2494:15;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;2494:15:7;;;;;;;;;;;;;;;;;;;;;:22;;:28;;;;:::i;:::-;2528:27;2540:4;2546:8;2528:27;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;2528:27:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2422:138;;:::o;2169:130::-;2238:25;2258:4;2238:5;2244:8;2238:15;;;;;;;;;;;;;36:153:-1;66:2;61:3;58:11;51:19;36:153;;;182:3;176:10;171:3;164:23;98:2;93:3;89:12;82:19;;123:2;118:3;114:12;107:19;;148:2;143:3;139:12;132:19;;36:153;;;274:1;267:3;263:2;259:12;254:3;250:22;246:30;315:4;311:9;305:3;299:10;295:26;356:4;350:3;344:10;340:21;389:7;380;377:20;372:3;365:33;3:399;;;2238:15:7;;;;;;;;;;;;;;;;;;;;;:19;;:25;;;;:::i;:::-;2269;2279:4;2285:8;2269:25;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;2269:25:7;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;2169:130;;:::o;10368:298:12:-;10479:4;10545:13;10496:16;:3;:14;;;:16::i;:::-;10495:17;10491:49;;;10529:4;10522:11;;;;10491:49;10576:3;10561:36;;;10598:5;10605:8;10615:5;10561:60;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;23:1:-1;8:100;33:3;30:1;27:10;8:100;;;99:1;94:3;90:11;84:18;80:1;75:3;71:11;64:39;52:2;49:1;45:10;40:15;;8:100;;;12:14;10561:60:12;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;10545:76;;605:10;10645:15;;10635:25;;;:6;:25;;;;10627:34;;10368:298;;;;;;;;:::o;9651:214::-;9753:5;9732:26;;:17;9740:8;9732:7;:17::i;:::-;:26;;;9724:35;;;;;;;;9791:30;9819:1;9791:16;:23;9808:5;9791:23;;;;;;;;;;;;;;;;:27;;:30;;;;:::i;:::-;9765:16;:23;9782:5;9765:23;;;;;;;;;;;;;;;:56;;;;9858:1;9827:10;:20;9838:8;9827:20;;;;;;;;;;;;:33;;;;;;;;;;;;;;;;;;9651:214;;:::o;835:110:6:-;893:7;920:1;915;:6;;908:14;;;;;;939:1;935;:5;928:12;;835:110;;;;:::o;9172:204:12:-;9278:1;9246:34;;:10;:20;9257:8;9246:20;;;;;;;;;;;;;;;;;;;;;:34;;;9238:43;;;;;;;;9310:3;9287:10;:20;9298:8;9287:20;;;;;;;;;;;;:26;;;;;;;;;;;;;;;;;;9343:28;9369:1;9343:16;:21;9360:3;9343:21;;;;;;;;;;;;;;;;:25;;:28;;;;:::i;:::-;9319:16;:21;9336:3;9319:21;;;;;;;;;;;;;;;:52;;;;9172:204;;:::o;7857:164::-;7941:1;7926:17;;:3;:17;;;;7918:26;;;;;;;;7950:25;7961:3;7966:8;7950:10;:25::i;:::-;8002:3;7981:35;;7998:1;7981:35;;;8007:8;7981:35;;;;;;;;;;;;;;;;;;7857:164;;:::o;487:100:8:-;577:5;557:4;:11;;:17;569:4;557:17;;;;;;;;;;;;;;;;:25;;;;;;;;;;;;;;;;;;487:100;;:::o;326:96::-;413:4;393;:11;;:17;405:4;393:17;;;;;;;;;;;;;;;;:24;;;;;;;;;;;;;;;;;;326:96;;:::o;451:150:4:-;508:4;520:12;569:4;557:17;549:25;;595:1;588:4;:8;581:15;;451:150;;;;:::o;1007:129:6:-;1065:7;1080:9;1096:1;1092;:5;1080:17;;1115:1;1110;:6;;1103:14;;;;;;1130:1;1123:8;;1007:129;;;;;:::o;59:1075:1:-;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::i;:::-;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o",
	"source": "pragma solidity ^0.4.21;\n\nimport \"./ButtonClickGame.sol\";\n\ncontract ButtonClickGameContract is ButtonClickGame {\n\n    /**\n     * Core constructer, which starts the game contact\n     */\n    function ButtonClickGameContract() public {\n        // The contract creator immediately takes over both Admin and Finance roles\n        addRole(msg.sender, ROLE_ADMIN);\n        addRole(msg.sender, ROLE_FINANCE);\n\n        minimumFee = 500000000000000; // 0.0005 ETH (hopefully low enough to not deter users, but high enough to avoid bots)\n        requiredBlocksElapsedForVictory = 20; // 20 blocks must elapse to win\n    }    \n\n    /**\n     * @dev Officially starts the game and configures all initial details\n     */\n    function startGame() external onlyAdmin {\n        require(!started);\n        started = true;\n        blockNumberForVictory = block.number + requiredBlocksElapsedForVictory;\n    }\n\n    /**\n     * @dev A simple function to allow for deposits into this contract. We use this\n     * instead of the fallback function to ensure that deposits are intentional \n     */\n    function sendDeposit() external payable {\n        \n    }\n\n}",
	"sourcePath": "/Users/williambaumann/workspace/Ethereum/theetherbutton/contracts/ButtonClickGameContract.sol",
	"ast": {
		"absolutePath": "/Users/williambaumann/workspace/Ethereum/theetherbutton/contracts/ButtonClickGameContract.sol",
		"exportedSymbols": {
			"ButtonClickGameContract": [
				265
			]
		},
		"id": 266,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 211,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".21"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:1"
			},
			{
				"absolutePath": "/Users/williambaumann/workspace/Ethereum/theetherbutton/contracts/ButtonClickGame.sol",
				"file": "./ButtonClickGame.sol",
				"id": 212,
				"nodeType": "ImportDirective",
				"scope": 266,
				"sourceUnit": 210,
				"src": "26:31:1",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": [],
						"baseName": {
							"contractScope": null,
							"id": 213,
							"name": "ButtonClickGame",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 209,
							"src": "95:15:1",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_ButtonClickGame_$209",
								"typeString": "contract ButtonClickGame"
							}
						},
						"id": 214,
						"nodeType": "InheritanceSpecifier",
						"src": "95:15:1"
					}
				],
				"contractDependencies": [
					209,
					327,
					346,
					694,
					817,
					837,
					844,
					951,
					1534,
					1922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 265,
				"linearizedBaseContracts": [
					265,
					209,
					327,
					346,
					694,
					1922,
					1534,
					844,
					837,
					817,
					951
				],
				"name": "ButtonClickGameContract",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 237,
							"nodeType": "Block",
							"src": "231:379:1",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 218,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1935,
													"src": "333:3:1",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 219,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "333:10:1",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 220,
												"name": "ROLE_ADMIN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 559,
												"src": "345:10:1",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory",
													"typeString": "string memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_string_memory",
													"typeString": "string memory"
												}
											],
											"id": 217,
											"name": "addRole",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 651,
											"src": "325:7:1",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (address,string memory)"
											}
										},
										"id": 221,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "325:31:1",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 222,
									"nodeType": "ExpressionStatement",
									"src": "325:31:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 224,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1935,
													"src": "374:3:1",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 225,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "374:10:1",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 226,
												"name": "ROLE_FINANCE",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 335,
												"src": "386:12:1",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory",
													"typeString": "string memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_string_memory",
													"typeString": "string memory"
												}
											],
											"id": 223,
											"name": "addRole",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 651,
											"src": "366:7:1",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (address,string memory)"
											}
										},
										"id": 227,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "366:33:1",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 228,
									"nodeType": "ExpressionStatement",
									"src": "366:33:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 231,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 229,
											"name": "minimumFee",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 275,
											"src": "410:10:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "353030303030303030303030303030",
											"id": 230,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "423:15:1",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_500000000000000_by_1",
												"typeString": "int_const 500000000000000"
											},
											"value": "500000000000000"
										},
										"src": "410:28:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 232,
									"nodeType": "ExpressionStatement",
									"src": "410:28:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 235,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 233,
											"name": "requiredBlocksElapsedForVictory",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 277,
											"src": "535:31:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "3230",
											"id": 234,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "569:2:1",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_20_by_1",
												"typeString": "int_const 20"
											},
											"value": "20"
										},
										"src": "535:36:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 236,
									"nodeType": "ExpressionStatement",
									"src": "535:36:1"
								}
							]
						},
						"documentation": "Core constructer, which starts the game contact",
						"id": 238,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "ButtonClickGameContract",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 215,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "221:2:1"
						},
						"payable": false,
						"returnParameters": {
							"id": 216,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "231:0:1"
						},
						"scope": 265,
						"src": "189:421:1",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 259,
							"nodeType": "Block",
							"src": "750:138:1",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 245,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "!",
												"prefix": true,
												"src": "768:8:1",
												"subExpression": {
													"argumentTypes": null,
													"id": 244,
													"name": "started",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 273,
													"src": "769:7:1",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 243,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1938,
											"src": "760:7:1",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 246,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "760:17:1",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 247,
									"nodeType": "ExpressionStatement",
									"src": "760:17:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 250,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 248,
											"name": "started",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 273,
											"src": "787:7:1",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 249,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "797:4:1",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "787:14:1",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 251,
									"nodeType": "ExpressionStatement",
									"src": "787:14:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 257,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 252,
											"name": "blockNumberForVictory",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 31,
											"src": "811:21:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 256,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 253,
													"name": "block",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1926,
													"src": "835:5:1",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_block",
														"typeString": "block"
													}
												},
												"id": 254,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "number",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "835:12:1",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "+",
											"rightExpression": {
												"argumentTypes": null,
												"id": 255,
												"name": "requiredBlocksElapsedForVictory",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 277,
												"src": "850:31:1",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "835:46:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "811:70:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 258,
									"nodeType": "ExpressionStatement",
									"src": "811:70:1"
								}
							]
						},
						"documentation": "@dev Officially starts the game and configures all initial details",
						"id": 260,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [],
								"id": 241,
								"modifierName": {
									"argumentTypes": null,
									"id": 240,
									"name": "onlyAdmin",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 693,
									"src": "740:9:1",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "740:9:1"
							}
						],
						"name": "startGame",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 239,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "728:2:1"
						},
						"payable": false,
						"returnParameters": {
							"id": 242,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "750:0:1"
						},
						"scope": 265,
						"src": "710:178:1",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 263,
							"nodeType": "Block",
							"src": "1115:16:1",
							"statements": []
						},
						"documentation": "@dev A simple function to allow for deposits into this contract. We use this\ninstead of the fallback function to ensure that deposits are intentional ",
						"id": 264,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "sendDeposit",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 261,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1095:2:1"
						},
						"payable": true,
						"returnParameters": {
							"id": 262,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1115:0:1"
						},
						"scope": 265,
						"src": "1075:56:1",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "external"
					}
				],
				"scope": 266,
				"src": "59:1075:1"
			}
		],
		"src": "0:1134:1"
	},
	"legacyAST": {
		"absolutePath": "/Users/williambaumann/workspace/Ethereum/theetherbutton/contracts/ButtonClickGameContract.sol",
		"exportedSymbols": {
			"ButtonClickGameContract": [
				265
			]
		},
		"id": 266,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 211,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".21"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:1"
			},
			{
				"absolutePath": "/Users/williambaumann/workspace/Ethereum/theetherbutton/contracts/ButtonClickGame.sol",
				"file": "./ButtonClickGame.sol",
				"id": 212,
				"nodeType": "ImportDirective",
				"scope": 266,
				"sourceUnit": 210,
				"src": "26:31:1",
				"symbolAliases": [],
				"unitAlias": ""
			},
			{
				"baseContracts": [
					{
						"arguments": [],
						"baseName": {
							"contractScope": null,
							"id": 213,
							"name": "ButtonClickGame",
							"nodeType": "UserDefinedTypeName",
							"referencedDeclaration": 209,
							"src": "95:15:1",
							"typeDescriptions": {
								"typeIdentifier": "t_contract$_ButtonClickGame_$209",
								"typeString": "contract ButtonClickGame"
							}
						},
						"id": 214,
						"nodeType": "InheritanceSpecifier",
						"src": "95:15:1"
					}
				],
				"contractDependencies": [
					209,
					327,
					346,
					694,
					817,
					837,
					844,
					951,
					1534,
					1922
				],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 265,
				"linearizedBaseContracts": [
					265,
					209,
					327,
					346,
					694,
					1922,
					1534,
					844,
					837,
					817,
					951
				],
				"name": "ButtonClickGameContract",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"body": {
							"id": 237,
							"nodeType": "Block",
							"src": "231:379:1",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 218,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1935,
													"src": "333:3:1",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 219,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "333:10:1",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 220,
												"name": "ROLE_ADMIN",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 559,
												"src": "345:10:1",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory",
													"typeString": "string memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_string_memory",
													"typeString": "string memory"
												}
											],
											"id": 217,
											"name": "addRole",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 651,
											"src": "325:7:1",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (address,string memory)"
											}
										},
										"id": 221,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "325:31:1",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 222,
									"nodeType": "ExpressionStatement",
									"src": "325:31:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 224,
													"name": "msg",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1935,
													"src": "374:3:1",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_message",
														"typeString": "msg"
													}
												},
												"id": 225,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "sender",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "374:10:1",
												"typeDescriptions": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												}
											},
											{
												"argumentTypes": null,
												"id": 226,
												"name": "ROLE_FINANCE",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 335,
												"src": "386:12:1",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory",
													"typeString": "string memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												{
													"typeIdentifier": "t_string_memory",
													"typeString": "string memory"
												}
											],
											"id": 223,
											"name": "addRole",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 651,
											"src": "366:7:1",
											"typeDescriptions": {
												"typeIdentifier": "t_function_internal_nonpayable$_t_address_$_t_string_memory_ptr_$returns$__$",
												"typeString": "function (address,string memory)"
											}
										},
										"id": 227,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "366:33:1",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 228,
									"nodeType": "ExpressionStatement",
									"src": "366:33:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 231,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 229,
											"name": "minimumFee",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 275,
											"src": "410:10:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "353030303030303030303030303030",
											"id": 230,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "423:15:1",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_500000000000000_by_1",
												"typeString": "int_const 500000000000000"
											},
											"value": "500000000000000"
										},
										"src": "410:28:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 232,
									"nodeType": "ExpressionStatement",
									"src": "410:28:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 235,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 233,
											"name": "requiredBlocksElapsedForVictory",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 277,
											"src": "535:31:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "3230",
											"id": 234,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "569:2:1",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_20_by_1",
												"typeString": "int_const 20"
											},
											"value": "20"
										},
										"src": "535:36:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 236,
									"nodeType": "ExpressionStatement",
									"src": "535:36:1"
								}
							]
						},
						"documentation": "Core constructer, which starts the game contact",
						"id": 238,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "ButtonClickGameContract",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 215,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "221:2:1"
						},
						"payable": false,
						"returnParameters": {
							"id": 216,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "231:0:1"
						},
						"scope": 265,
						"src": "189:421:1",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 259,
							"nodeType": "Block",
							"src": "750:138:1",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 245,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"nodeType": "UnaryOperation",
												"operator": "!",
												"prefix": true,
												"src": "768:8:1",
												"subExpression": {
													"argumentTypes": null,
													"id": 244,
													"name": "started",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 273,
													"src": "769:7:1",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 243,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1938,
											"src": "760:7:1",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 246,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "760:17:1",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 247,
									"nodeType": "ExpressionStatement",
									"src": "760:17:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 250,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 248,
											"name": "started",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 273,
											"src": "787:7:1",
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"hexValue": "74727565",
											"id": 249,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "bool",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "797:4:1",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_bool",
												"typeString": "bool"
											},
											"value": "true"
										},
										"src": "787:14:1",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"id": 251,
									"nodeType": "ExpressionStatement",
									"src": "787:14:1"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 257,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 252,
											"name": "blockNumberForVictory",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 31,
											"src": "811:21:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"commonType": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											},
											"id": 256,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"leftExpression": {
												"argumentTypes": null,
												"expression": {
													"argumentTypes": null,
													"id": 253,
													"name": "block",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1926,
													"src": "835:5:1",
													"typeDescriptions": {
														"typeIdentifier": "t_magic_block",
														"typeString": "block"
													}
												},
												"id": 254,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"memberName": "number",
												"nodeType": "MemberAccess",
												"referencedDeclaration": null,
												"src": "835:12:1",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"nodeType": "BinaryOperation",
											"operator": "+",
											"rightExpression": {
												"argumentTypes": null,
												"id": 255,
												"name": "requiredBlocksElapsedForVictory",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 277,
												"src": "850:31:1",
												"typeDescriptions": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												}
											},
											"src": "835:46:1",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "811:70:1",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 258,
									"nodeType": "ExpressionStatement",
									"src": "811:70:1"
								}
							]
						},
						"documentation": "@dev Officially starts the game and configures all initial details",
						"id": 260,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [
							{
								"arguments": [],
								"id": 241,
								"modifierName": {
									"argumentTypes": null,
									"id": 240,
									"name": "onlyAdmin",
									"nodeType": "Identifier",
									"overloadedDeclarations": [],
									"referencedDeclaration": 693,
									"src": "740:9:1",
									"typeDescriptions": {
										"typeIdentifier": "t_modifier$__$",
										"typeString": "modifier ()"
									}
								},
								"nodeType": "ModifierInvocation",
								"src": "740:9:1"
							}
						],
						"name": "startGame",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 239,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "728:2:1"
						},
						"payable": false,
						"returnParameters": {
							"id": 242,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "750:0:1"
						},
						"scope": 265,
						"src": "710:178:1",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "external"
					},
					{
						"body": {
							"id": 263,
							"nodeType": "Block",
							"src": "1115:16:1",
							"statements": []
						},
						"documentation": "@dev A simple function to allow for deposits into this contract. We use this\ninstead of the fallback function to ensure that deposits are intentional ",
						"id": 264,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "sendDeposit",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 261,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1095:2:1"
						},
						"payable": true,
						"returnParameters": {
							"id": 262,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "1115:0:1"
						},
						"scope": 265,
						"src": "1075:56:1",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "external"
					}
				],
				"scope": 266,
				"src": "59:1075:1"
			}
		],
		"src": "0:1134:1"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.21+commit.dfe3193c.Emscripten.clang"
	},
	"networks": {
		"1": {
			"events": {},
			"links": {},
			"address": "0xdeafc8d49ea6d6044eaa53f5e7c7c35c60e13d7f",
			"transactionHash": "0x740a5cbcc057fe09be0e874ac4a34912fef2653876f2cbfd17a814e1c13f623a"
		},
		"3": {
			"events": {},
			"links": {},
			"address": "0x945687adcc12b818c46f4dc6834712ed40345093",
			"transactionHash": "0xa8eba65fbde8fd6b0585796091ecd497ef27a8fdd6118a72fcad782e977fb2e4"
		},
		"4447": {
			"events": {},
			"links": {},
			"address": "0x345ca3e014aaf5dca488057592ee47305d9b3e10",
			"transactionHash": "0xc5eb6fdb6d85881bd19a71415037bad0d587c2986fe0cf9b8ebbf45e796c6854"
		}
	},
	"schemaVersion": "2.0.0",
	"updatedAt": "2018-05-31T18:07:33.105Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/ButtonClickGameContract.json
// module id = 449
// module chunks = 0